/** File for shared data models between front and back end */

const { VEHICLE_FIELDS } = require('../origination/fields');

const GENERAL_FIELDS = {
  ID: '_id',
  MONGO_ID: '_id', // Deprecated
  CREATED_UTC: 'createdUtc',
  UPDATED_UTC: 'lastModUtc'
};

const FOREIGN_KEYS = {
  ORIGINATION: 'fk_origination',
  JOURNEY: 'fk_journey',
  VISIT: 'fk_visit',
  VISITOR: 'fk_visitor',
  B_QUOTESET: 'fk_bQuoteSet',
  CARRIER_PRODUCT: 'fk_carrierProduct_productId',
  CARRIER_CODE: 'fk_carrier_carrierCode',
  CONSUMER: 'fk_consumer',
  B_QUOTES: 'fk_bquotes',
  B_QUOTE: 'fk_bQuote',
  PARTNER_ACCOUNT: 'fk_partner_accountId',
  PARTNER_GROUPING_ACCOUNT: 'fk_partner_groupingAccountId',
  ORIGINATOR: 'fk_originator',
  USER: 'fk_user',
  POLICY: 'fk_policy',
  AGENT: 'fk_agent',
  REPORT: 'fk_report',
  GS_USER: 'fk_gs_user',
  QUOTE_APP: 'fk_quote_app',
  QUOTE_REQUEST: 'fk_quote_request',
  QUOTE_RESULT: 'fk_quote_result'
};

const BUNDLED_QUOTE_FIELDS = {
  QUOTE_IDS: 'quoteIds',
  VIEWED: 'viewed'
};

const QUOTESET_FIELDS = {
  CONSUMER_INFO: 'consumerInfo',
  COVERAGE_TYPE: 'coverageType',
  EXTERNAL_ID: 'externalId',
  FINALIZATION: 'finalization',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MORTGAGE: 'mortgage',
  STATUS: 'status',
  SUPPLEMENTARY_INFO: 'supplementaryInfo',
  VERTAFORE_XML: 'vertaforeXml',
  VERTAFORE: 'vertafore',
  AGENT_NOTES: 'agentNotes',
  REQUESTED: 'requested',
  VIEWED: 'viewed'
};

const VERTAFORE_FIELDS = {
  URL: 'url',
  XML: 'xml'
};

const FINALIZATION_FIELDS = {
  TYPE: 'type',
  DATE: 'date',
  QUOTES_READY_URL: 'quotesReadyUrl',
  EMAIL_DATA: 'emailData',
  SENT_TO_CLIENT: 'sentToClient'
};

/**
 * Subobject on finalization
 */
const EMAIL_DATA_FIELDS = {
  SAVINGS: 'savings',
  CARRIERS: 'carriers'
};

const PARTNER_FIELDS = {
  ACCOUNT_ID: 'accountId',
  GROUPING_ACCOUNT_ID: 'groupingAccountId',
  NAME: 'name',
  LEGAL_NAME: 'legalName',
  BASE_MARKETING_SITE: 'baseMarketingSite',
  SUPPORT_PHONE_NUMBER: 'supportPhoneNumber',
  INACTIVE: 'inactive',
  MNEMONIC: 'mnemonic',
  MNEMONIC_LAUNCH_EXT: 'mnemonicLaunchExt',
  BRANDED_DOMAIN: 'brandedDomain', // For creating SHORTIO URL
  BRANDED_BROWSER_TAB_TITLE: 'brandedBrowserTabTitle', // For SHORTIO's browser tab title configuration
  APPLY_ORIGINATOR_BRANDING: 'applyOriginatorBranding',
  APP_CONFIG: 'appConfig',
  EMAIL_CONFIG: 'emailConfig',
  APP_LAUNCH_URL: 'altAppLaunchUrl',
  GARAGESHARE: 'garageshare'
};

const GARAGESHARE_FIELDS = {
  ACTIVE: 'active'
};

const APP_CONFIG_FIELDS = {
  LOGO_URL: 'logoUrl',
  LOGO_MOBILE_URL: 'logoMobileUrl',
  HTML_TITLE: 'htmlTitle',
  FAVICON_URL: 'faviconUrl'
};

const EMAIL_CONFIG_FIELDS = {
  CONSUMER_FROM_EMAIL: 'consumerFromEmail',
  INSURANCE_EMAIL: 'insuranceEmail', // Forward insurance documentation to this email.
  FROM_NAME: 'fromName',
  CTA_COLOR: 'ctaColor',
  LOGO_URL: 'logoUrl',
  LOGO_MOBILE_URL: 'logoMobileUrl',
  SIGNATURE_NAME: 'signatureName'
};

const QUOTE_FIELDS = {
  ADDITIONAL_COVERAGES: 'additionalCoverages',
  CARRIER_QUOTE_ID: 'carrierQuoteId',
  COVERAGES: 'coverages',
  COVERAGE_TAG: 'coverageTag',
  COVERAGE_TYPE: 'coverageType',
  DEDUCTIBLE: 'deductible',
  EXTERNAL_ID: 'externalId',
  FEES: 'fees',
  IS_CURRENT_POLICY: 'isCurrentPolicy',
  PREMIUMS: 'premiums',
  RECOMMENDED: 'recommended',
  SELECTED: 'selected',
  DISCOUNTS: 'discounts',
  PDF: 'pdf',
  VIEWED: 'viewed'
};

const PDF_FIELDS = {
  FILENAME: 'filename',
  URL: 'url'
};

const DISCOUNT_FIELDS = {
  TYPE: 'type'
};

const MORTGAGE_FIELDS = {
  COMPANY_NAME: 'companyName',
  COMPANY_CITY: 'companyCity',
  COMPANY_STATE: 'companyState',
  LOAN_NUMBER: 'loanNumber'
};

const SUPPLEMENTARY_INFO_FIELDS = {
  COMPANY_OWNED: 'companyOwned',
  ELECTRICAL_BREAKER: 'electricalBreaker',
  ELECTRICAL_BREAKER_100: 'electricalBreaker100amps',
  FELON: 'felon',
  FORECLOSURE: 'foreclosure',
  FOUNDATION_TYPE: 'foundationType',
  HAS_SWIMMING_POOL: 'hasSwimmingPool',
  HEATING_TYPE: 'heatingType',
  INSURANCE_FRAUD: 'insuranceFraud',
  NUMBER_OF_STORIES: 'numberOfStories',
  NUMBER_OF_UNITS: 'numberOfUnits',
  POLICY_CANCELED: 'policyCanceled',
  POOL_HAS_DIVING_BOARD: 'poolHasDivingBoard',
  POOL_HAS_FENCE: 'poolHasFence',
  POOL_HAS_SLIDE: 'poolHasSlide',
  POOL_TYPE: 'poolType',
  ROOF_SHAPE: 'roofShape',
  ROOF_TYPE: 'roofType',
  SQUARE_FOOTAGE: 'squareFootage',
  TRAMPOLINE: 'trampoline',
  TRAMPOLINE_HAS_NET: 'trampolineHasNet',
  UNDER_CONSTRUCTION: 'underConstruction',
  VISIBLE_DAMAGE: 'visibleDamage'
};

/**
 * Events for funnel tracking, stored on origination object
 */
const EVENT_FIELDS = {
  APPLICATION_STARTED: 'applicationStarted',
  CANOPY_CONNECTED: 'canopyConnected',
  UPLOADED_DOCUMENTS: 'uploadedDocuments',
  APPLICATION_COMPLETED: 'applicationCompleted',
  QUOTES_VISITED: 'quotesVisited',
  QUOTES_CONFIRMED: 'quotesConfirmed'
};

const ORIGINATION_FIELDS = {
  ACCOUNT: 'account',
  ORIGINATION_DATA: 'originationData',
  CREATED_BY: 'createdBy',
  COMMENTS: 'comments',
  FILES: 'files',
  PULLS: 'pulls',
  UPDATED_FROM: 'updatedFrom',
  CARRIERS: 'carriers', // Stored within finalization object
  SAVINGS: 'savings', // Stored within finalization object,
  UNSUBSCRIBE: 'unsubscribe',
  JOURNEY_READY_REMINDER: 'journeyReadyReminder', // Stored within unsubscribe object
  JOURNEY_REMINDER: 'journeyReminder', // Stored within unsubscribe object
  QUOTES_REMINDER: 'quotesReminder', // Stored within unsubscribe object
  FINALIZATION: 'finalization',
  EVENTS: 'events',
  ATTRIBUTION: 'attribution',
  DOCUMENTS: 'documents',
  LOAD: 'load',
  IV_CONTACT_DATE: 'ivContactDate',
  IV_CONTACT_FAILED_DATE: 'ivContactFailedDate'
};

/**
 * Subobject on origination
 */
const ACCOUNT_FIELDS = {
  ACCOUNT_ID: 'accountId',
  EXTERNAL_ORIGINATOR_ID: 'externOriginatorId'
};

const USER_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DOB: 'dob',
  PHONE: 'phone',
  EMAIL: 'email',
  PASSWORD: 'password',
  SIGN_UP_DATE: 'signUpDate',
  SCENARIO: 'scenario'
};

/**
 * A superset of USER_FIELDS that includes GarageShare-specific fields
 */
const GS_USER_FIELDS = {
  ...USER_FIELDS,
  ACCOUNT_IDS: 'accountIds'
};

/**
 * Represents an insurance report which we display to the user on UIPortal.
 * Foreign Keys: fk_bQuoteSet, fk_user, fk_agent, fk_policy.
 */
const REPORT_FIELDS = {
  NOTES: 'notes',
  STATUS: 'status',
  POLICY_TYPE: 'policyType',
  CARRIER_POLICY_ID: 'carrierPolicyId',
  CARRIER_SLUG: 'carrierSlug',
  ADDRESS: 'address',
  VEHICLES: 'vehicles',
  SCORES: 'scores',
  SCORE_OVERRIDES: 'scoreOverrides',
  FINALIZATION: 'finalization',
  INSURANCE_HISTORY: 'insuranceHistory',
  YEARS_CONTINUOUSLY_INSURED: 'yearsContinuouslyInsured', // In insuranceHistory
  RECENTLY_PURCHASED: 'recentlyPurchased', // In vehicles
  STATE_PREMIUM: 'statePremium',
  ANNUAL_PREMIUM: 'annualPremium',
  VIEWED: 'viewed',
  PERSONAL_LIABILITY: 'personalLiability',
  RISKS: 'risks',
  REPLACEMENT_COST: 'replacementCost',
  YEAR_ROOF_REPLACED: 'yearRoofReplaced',
  IS_PREVIEW: 'isPreview',
  INSURANCE_SCORE: 'insuranceScore',
  CREATED_BY: 'createdBy'
};

const STATE_PREMIUM_FIELDS = {
  LOWER_BOUND: 'lowerBound',
  UPPER_BOUND: 'upperBound',
  AVERAGE: 'average'
};

const PERSONAL_LIABILITY_FIELDS = {
  POOL: 'pool',
  TRAMPOLINE: 'trampoline',
  DOG: 'dog'
};

/**
 * Subsections of the scores associated with a report.
 */
const SCORE_SECTIONS = {
  INSURANCE_HISTORY: 'insuranceHistory',
  DRIVING_HISTORY: 'drivingHistory',
  LOCATION: 'location',
  VEHICLES: 'vehicles',
  DRIVERS: 'drivers',
  REPLACEMENT_COST: 'replacementCost',
  FIRE_PROTECTION: 'fireProtection',
  CLAIMS_HISTORY: 'claimsHistory',
  PERSONAL_LIABILITY: 'personalLiability',
  BURGLARY: 'burglary',
  ROOF_AGE: 'roofAge',
  INSURANCE_SCORE: 'insuranceScore'
};

/**
 * Score fields for each section of scores.
 *
 * Values for each will be an integer from (1-5), with 1 being the lowest
 * and 5 the highest.
 */
const SCORE_FIELDS = {
  OVERALL: 'overall',

  // Insurance History
  YEARS_INSURED: 'yearsInsured',
  CURRENT_LIMITS: 'currentLimits',

  // Location
  ZIP: 'zip',

  // Drivers
  NUM_OF_DRIVERS: 'numOfDrivers',
  AGE_OF_DRIVERS: 'ageOfDrivers',

  // Driving History
  ACCIDENTS: 'accidents',
  CLAIMS: 'claims',
  VIOLATIONS: 'violations',

  // Vehicles
  NUM_OF_VEHICLES: 'numOfVehicles',
  RECENTLY_PURCHASED: 'recentlyPurchased',

  // Replacement Cost
  REPLACEMENT_COST: 'replacementCost',

  // Fire Protection
  DISTANCE_TO_HYDRANT: 'distanceToHydrant',
  DISTANCE_TO_STATION: 'distanceToStation',

  // Personal Liability
  POOL: 'pool',
  TRAMPOLINE: 'trampoline',
  DOG: 'dog',

  // Burglary
  BURGLARY: 'burglary',

  // Roof Age
  ROOF_AGE: 'roofAge',

  // Insurance Score
  INSURANCE_SCORE: 'insuranceScore'
};

const AGENT_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  IMAGE_URL: 'imageUrl',
  ACTIVE: 'active'
};

const COVERAGE_TEMPLATE_FIELDS = {
  POLICY_TYPE: 'policyType',
  STATE: 'state',
  COVERAGES: 'coverages'
};

const CARRIER_FIELDS = {
  CODE: 'code',
  NAME: 'name',
  SLUG: 'slug', // A canopy carrier slug.
  YEAR_FOUNDED: 'yearFounded',
  LOGO_URL: 'logoUrl',
  URL: 'url',
  PHONE: 'phone',
  FACTS: 'facts',
  PARENT_COMPANY: 'parentCompany',
  ACCENT_COLOR: 'accentColor',
  FEES: 'fees',
  LIVE: 'live',
  RECURRING_PAYMENT_LANGUAGE: 'recurringPaymentLanguage',
  ZYWAVE: 'zywave'
};

const GS_VEHICLE_FIELDS = {
  ...VEHICLE_FIELDS,
  CREATED_BY: 'createdBy',
  SERVICE_DATE: 'serviceDate',
  STATUS: 'status',
  NOTES: 'notes',
  CUSTOMER_ID: 'customerId',
  DEAL_ID: 'dealId',
  SALES_REP_NAME: 'salesRepName',
  ASSOCIATED_FIRST_NAME: 'associatedFirstName',
  ASSOCIATED_LAST_NAME: 'associatedLastName',
  ASSOCIATED_EMAIL: 'associatedEmail'
};

const LEXISNEXIS_FIELDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName'
};

const BINDINGS_FIELDS = {
  PAYMENT_PLAN: 'paymentPlan',
  PAYMENT_METHOD: 'paymentMethod',
  PAYMENT_INFO: 'paymentInfo',
  BILLING_INFO: 'billingInfo',
  E_DOCUMENT_AGREEMENT: 'eDocumentAgreement',
  BILLING_FIRST_NAME: 'billingFirstName',
  BILLING_LAST_NAME: 'billingLastName',
  BILLING_ADDRESS: 'billingAddress',
  MORTGAGE: 'mortgage', // see MORTGAGE_FIELDS
  NAME_ON_CARD: 'nameOnCard', // Held in CRM.
  CARD_NUMBER: 'cardNumber', // Held in CRM.
  CVV: 'cvv', // Held in CRM.
  EXPIRY_MONTH: 'expiryMonth', // Held in CRM.
  EXPIRY_YEAR: 'expiryYear', // Held in CRM.
  BANK_NAME: 'bankName',
  ACCOUNT_NUMBER: 'acctNumber', // Held in CRM.
  ROUTING_NUMBER: 'routingNumber', // Held in CRM.
  STATUS: 'status',
  PROCESSED_DATE: 'processedDate',
  FEES: 'fees',
  PREMIUM: 'premium',
  COVERAGE_TYPE: 'coverageType',
  LEGAL: 'legal'
};

const LEGAL_FIELDS = {
  RECURRING: 'recurring', // Stored within legal object
  NAME: 'name',
  DATE: 'date',
  LANGUAGE: 'language'
};

const QUOTE_REQUEST_FIELDS = {
  // FK_QUOTE_APP
  BUNDLED_REQUESTS: 'bundledRequests',
  REQUESTS: 'requests',
  // quoteReqest.request fields:
  EFFECTIVE_DATE: 'effectiveDate',
  TYPE: 'type',
  LOB: 'lob',
  ID: 'id',
  TERM_LENGTH: 'termLength',
  CARRIERS: 'carriers',
  COVERAGES: 'coverages',
  SKIP: 'skip',
  BUNDLED_ONLY: 'bundledOnly',
  PROPERTY_ID: 'propertyId',
  ADDRESS: 'address',
  VEHICLES: 'vehicles',
  XML: 'xml',
  TRANSACTION_ID: 'transactionId'
};

const QUOTE_RESULT_FIELDS = {
  // FK_QUOTE_APP
  // FK_QUOTE_REQUEST
  ID: 'id',
  BUNDLED_REQUESTS: 'bundledRequests',
  ITEMS: 'items',
  // Item fields:
  REQUEST_ID: 'requestId',
  LOB: 'lob',
  TYPE: 'type',
  CARRIER: 'carrier',
  TERM_LENGTH: 'termLength',
  TOTAL_PREMIUM: 'totalPremium',
  PREMIUM: 'premium',
  URL: 'url',
  WARNINGS: 'warnings',
  ERRORS: 'errors',
  INFO: 'info',
  FULL_RESULT: 'fullResult'
};

const HOME_AVG_PREMIUM_FIELDS = {
  AVG_PREMIUMS: 'avgPremiums',
  ADJUSTMENT_FACTOR: 'adjustmentFactor',
  STATE: 'state',
  YEAR: 'year'
};

const CARRIER_STATS_FIELDS = {
  STATE: 'state',
  LOB: 'lob',
  CARRIER: 'carrier',
  COMPANIES: 'companies', // Object of underwriting company => policyholders
  POLICYHOLDERS: 'policyholders',
  SIZE_IN_STATE: 'sizeInState'
};

const CARRIER_RATE_CHANGES_FIELDS = {
  STATE: 'state',
  LOB: 'lob',
  CARRIER: 'carrier',
  RATE_CHANGE: 'rateChange',
  DATE: 'date'
};

const CARRIER_RATE_CHANGES_BY_YEAR_FIELDS = {
  STATE: 'state',
  LOB: 'lob',
  CARRIER: 'carrier',
  RATE_CHANGE: 'rateChange',
  YEAR: 'year'
};

const STATE_RATE_CHANGES_BY_YEAR_FIELDS = {
  STATE: 'state',
  LOB: 'lob',
  RATE_CHANGE: 'rateChange',
  YEAR: 'year'
};

module.exports = {
  USER_FIELDS,
  GS_USER_FIELDS,
  GENERAL_FIELDS,
  QUOTESET_FIELDS,
  QUOTE_FIELDS,
  MORTGAGE_FIELDS,
  BUNDLED_QUOTE_FIELDS,
  SUPPLEMENTARY_INFO_FIELDS,
  EVENT_FIELDS,
  AGENT_FIELDS,
  FINALIZATION_FIELDS,
  EMAIL_DATA_FIELDS,
  ORIGINATION_FIELDS,
  ACCOUNT_FIELDS,
  VERTAFORE_FIELDS,
  REPORT_FIELDS,
  PERSONAL_LIABILITY_FIELDS,
  SCORE_SECTIONS,
  SCORE_FIELDS,
  FOREIGN_KEYS,
  COVERAGE_TEMPLATE_FIELDS,
  STATE_PREMIUM_FIELDS,
  DISCOUNT_FIELDS,
  PDF_FIELDS,
  CARRIER_FIELDS,
  GS_VEHICLE_FIELDS,
  LEXISNEXIS_FIELDS,
  BINDINGS_FIELDS,
  LEGAL_FIELDS,
  PARTNER_FIELDS,
  APP_CONFIG_FIELDS,
  EMAIL_CONFIG_FIELDS,
  GARAGESHARE_FIELDS,
  QUOTE_REQUEST_FIELDS,
  QUOTE_RESULT_FIELDS,
  HOME_AVG_PREMIUM_FIELDS,
  CARRIER_STATS_FIELDS,
  CARRIER_RATE_CHANGES_FIELDS,
  CARRIER_RATE_CHANGES_BY_YEAR_FIELDS,
  STATE_RATE_CHANGES_BY_YEAR_FIELDS
};
